module.exports = __webpack_public_path__ + "static/media/3.b2c52c66.gif";